export default "__VITE_ASSET__BcTj2DHu__"